module.exports = __webpack_public_path__ + "static/img/logo.accf05a0.png";